/* NobaStore — scripts propios (prefijo nb-). Cada init comprueba si su elemento existe. */
(function () {
  if (window.__nbIniciado) return;
  window.__nbIniciado = true;

  function initReveal() {
    var els = document.querySelectorAll('.nb-reveal');
    if (!els.length) return;
    if (!('IntersectionObserver' in window) || window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
      els.forEach(function (el) { el.classList.add('nb-visible'); });
      return;
    }
    var io = new IntersectionObserver(function (entradas) {
      entradas.forEach(function (e) {
        if (e.isIntersecting) { e.target.classList.add('nb-visible'); io.unobserve(e.target); }
      });
    }, { threshold: 0.12, rootMargin: '0px 0px -40px 0px' });
    els.forEach(function (el) { io.observe(el); });
    /* Respaldo: si el observador no se dispara (algunos navegadores en segundo plano), revela al hacer scroll */
    var pendiente = false;
    function revisar() {
      pendiente = false;
      document.querySelectorAll('.nb-reveal:not(.nb-visible)').forEach(function (el) {
        if (el.getBoundingClientRect().top < window.innerHeight) el.classList.add('nb-visible');
      });
    }
    window.addEventListener('scroll', function () {
      if (!pendiente) { pendiente = true; requestAnimationFrame(revisar); }
    }, { passive: true });
    setTimeout(revisar, 1200);
  }

  function initGaleria() {
    document.querySelectorAll('[data-nb-galeria]').forEach(function (gal) {
      var principal = gal.querySelector('[data-nb-principal]');
      if (!principal) return;
      gal.querySelectorAll('[data-nb-thumb]').forEach(function (btn) {
        btn.addEventListener('click', function () {
          principal.style.opacity = '0';
          setTimeout(function () {
            principal.src = btn.getAttribute('data-src');
            principal.srcset = btn.getAttribute('data-srcset') || '';
            principal.alt = btn.getAttribute('data-alt') || '';
            principal.style.opacity = '1';
          }, 150);
          gal.querySelectorAll('[data-nb-thumb]').forEach(function (b) { b.classList.remove('is-activa'); });
          btn.classList.add('is-activa');
        });
      });
    });
  }

  function initVariantes() {
    document.querySelectorAll('[data-nb-producto]').forEach(function (raiz) {
      var datos = raiz.querySelector('[data-nb-variantes]');
      var selects = raiz.querySelectorAll('[data-nb-opcion]');
      if (!datos || !selects.length) return;
      var variantes = JSON.parse(datos.textContent);
      function actualizar() {
        var elegidas = Array.prototype.map.call(selects, function (s) { return s.value; });
        var v = variantes.find(function (x) {
          return x.opciones.every(function (o, i) { return o === elegidas[i]; });
        });
        var boton = raiz.querySelector('[data-nb-boton]');
        raiz.querySelectorAll('input[name="id"]').forEach(function (inp) { inp.value = v ? v.id : ''; });
        raiz.querySelectorAll('[data-nb-precio]').forEach(function (el) { el.textContent = v ? v.precio : ''; });
        raiz.querySelectorAll('[data-nb-antes]').forEach(function (el) { el.textContent = v && v.antes ? v.antes : ''; el.hidden = !(v && v.antes); });
        raiz.querySelectorAll('[data-nb-ahorro]').forEach(function (el) { el.textContent = v && v.ahorro ? el.getAttribute('data-plantilla').replace('[n]', v.ahorro) : ''; el.hidden = !(v && v.ahorro); });
        if (boton) {
          var disponible = v && v.disponible;
          boton.disabled = !disponible;
          boton.textContent = disponible ? boton.getAttribute('data-texto') : boton.getAttribute('data-agotado');
        }
        if (v && history.replaceState) {
          var url = new URL(window.location.href);
          url.searchParams.set('variant', v.id);
          history.replaceState({}, '', url.toString());
        }
        raiz.dispatchEvent(new CustomEvent('nb:variante', { detail: v, bubbles: true }));
      }
      selects.forEach(function (s) { s.addEventListener('change', actualizar); });
    });
  }

  /* Botones "Pedir ahora" de la barra fija y del cierre: abren el formulario de compra principal */
  function initDisparadores() {
    var zona = document.getElementById('nb-comprar');
    if (!zona) return;
    function abrir(e) {
      e.preventDefault();
      var objetivo = zona.querySelector('._rsi-buy-now-button, .shopify-app-block button, .shopify-app-block a, .shopify-app-block [role="button"], [data-nb-boton]:not([disabled])');
      zona.scrollIntoView({ behavior: 'smooth', block: 'center' });
      if (objetivo && zona.getAttribute('data-abrir') === 'true') {
        setTimeout(function () { objetivo.click(); }, 450);
      }
    }
    document.querySelectorAll('[data-nb-disparar]').forEach(function (b) { b.addEventListener('click', abrir); });

    var barra = document.querySelector('[data-nb-barra]');
    if (barra) {
      var pendiente = false;
      function revisar() {
        pendiente = false;
        barra.classList.toggle('is-visible', zona.getBoundingClientRect().bottom < 0);
      }
      window.addEventListener('scroll', function () {
        if (!pendiente) { pendiente = true; requestAnimationFrame(revisar); }
      }, { passive: true });
      revisar();
    }
  }

  /* Movimiento suave de imágenes al hacer scroll. data-nb-parallax = intensidad (0 = fija) */
  function initParallax() {
    var els = Array.prototype.filter.call(document.querySelectorAll('[data-nb-parallax]'), function (el) {
      return parseFloat(el.getAttribute('data-nb-parallax')) > 0;
    });
    if (!els.length || window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
    var pendiente = false;
    function mover() {
      pendiente = false;
      var alto = window.innerHeight;
      els.forEach(function (el) {
        var caja = (el.parentElement || el).getBoundingClientRect();
        if (caja.bottom < 0 || caja.top > alto) return;
        var progreso = (caja.top + caja.height / 2 - alto / 2) / alto; /* -1 … 1 */
        var fuerza = parseFloat(el.getAttribute('data-nb-parallax'));
        el.style.setProperty('--nb-py', (progreso * -fuerza * 1.5).toFixed(1) + 'px');
      });
    }
    window.addEventListener('scroll', function () {
      if (!pendiente) { pendiente = true; requestAnimationFrame(mover); }
    }, { passive: true });
    mover();
  }

  /* Carrusel de reseñas: flechas que desplazan una tarjeta */
  function initCarrusel() {
    document.querySelectorAll('[data-nb-carrusel]').forEach(function (c) {
      var pista = c.querySelector('[data-nb-pista]');
      if (!pista) return;
      function paso() { var t = pista.firstElementChild; return t ? t.getBoundingClientRect().width + 18 : 300; }
      var prev = c.querySelector('[data-nb-prev]');
      var next = c.querySelector('[data-nb-next]');
      if (prev) prev.addEventListener('click', function () { pista.scrollBy({ left: -paso(), behavior: 'smooth' }); });
      if (next) next.addEventListener('click', function () { pista.scrollBy({ left: paso(), behavior: 'smooth' }); });
    });
  }

  /* Packs de unidades: al abrir el formulario de Releasit se marca la misma oferta elegida en la página */
  function initPacks() {
    var cont = document.querySelector('[data-nb-packs]');
    if (!cont) return;
    var packs = cont.querySelectorAll('[data-nb-pack]');
    var activo = cont.querySelector('.nb-pack.is-activo') || packs[0];
    var oferta = activo ? parseInt(activo.getAttribute('data-nb-pack'), 10) : 1;
    var prepago = document.querySelector('[data-nb-prepago]');

    /* Botón de pago anticipado: va al checkout del pack elegido */
    function actualizarPrepago(p) {
      if (!prepago) return;
      var url = p.getAttribute('data-url-online');
      prepago.style.display = url ? '' : 'none';
      if (url) prepago.setAttribute('href', url);
      var precio = prepago.querySelector('[data-nb-prepago-precio]');
      if (precio) precio.textContent = p.getAttribute('data-precio-online') || '';
    }

    /* Regalos: se desbloquean según el pack elegido */
    function actualizarRegalos() {
      document.querySelectorAll('[data-nb-regalo-desde]').forEach(function (r) {
        var desde = parseInt(r.getAttribute('data-nb-regalo-desde'), 10) || 1;
        r.classList.toggle('is-bloqueado', oferta < desde);
      });
    }
    actualizarRegalos();

    packs.forEach(function (p) {
      p.addEventListener('click', function () {
        packs.forEach(function (x) { x.classList.remove('is-activo'); x.setAttribute('aria-checked', 'false'); });
        p.classList.add('is-activo');
        p.setAttribute('aria-checked', 'true');
        oferta = parseInt(p.getAttribute('data-nb-pack'), 10) || 1;
        actualizarRegalos();
        actualizarPrepago(p);
      });
    });

    function pulsar(el) {
      ['pointerdown', 'mousedown', 'pointerup', 'mouseup', 'click'].forEach(function (t) {
        el.dispatchEvent(new MouseEvent(t, { bubbles: true, cancelable: true, view: window }));
      });
    }
    function marcarOferta() {
      var intentos = 0;
      var t = setInterval(function () {
        intentos++;
        var modal = document.getElementById('_rsi-cod-form-modal');
        var ofertas = modal ? modal.querySelectorAll('._rsi-quantity-offers-offer-container') : [];
        if (ofertas.length >= oferta) {
          clearInterval(t);
          var o = ofertas[oferta - 1];
          if (!o.classList.contains('_rsi-quantity-offers-selected')) pulsar(o.querySelector('._rsi-quantity-offers-offer') || o);
        } else if (intentos > 30) clearInterval(t);
      }, 150);
    }
    document.addEventListener('click', function (e) {
      if (e.target.closest && e.target.closest('._rsi-buy-now-button')) marcarOferta();
    }, true);
  }

  /* Opciones con pago online: el botón único lleva al checkout de la opción elegida */
  function initOnline() {
    document.querySelectorAll('[data-nb-online]').forEach(function (cont) {
      var boton = cont.querySelector('[data-nb-online-boton]');
      var opciones = cont.querySelectorAll('[data-url]');
      if (!boton) return;
      opciones.forEach(function (o) {
        o.addEventListener('click', function () {
          opciones.forEach(function (x) { x.classList.remove('is-activo'); x.setAttribute('aria-checked', 'false'); });
          o.classList.add('is-activo');
          o.setAttribute('aria-checked', 'true');
          boton.setAttribute('href', o.getAttribute('data-url'));
          boton.textContent = o.getAttribute('data-texto');
        });
      });
    });
  }

  /* Pestañas */
  function initTabs() {
    document.querySelectorAll('[data-nb-tabs]').forEach(function (t) {
      var botones = t.querySelectorAll('[data-nb-tab]');
      var paneles = t.querySelectorAll('[data-nb-panel]');
      botones.forEach(function (b) {
        b.addEventListener('click', function () {
          var i = b.getAttribute('data-nb-tab');
          botones.forEach(function (x) { var on = x === b; x.classList.toggle('is-activa', on); x.setAttribute('aria-selected', on ? 'true' : 'false'); });
          paneles.forEach(function (p) { p.hidden = p.getAttribute('data-nb-panel') !== i; });
        });
      });
    });
  }

  /* Línea de tiempo del envío: fechas estimadas en días hábiles (lunes a viernes) */
  function initEnvio() {
    var meses = ['ene', 'feb', 'mar', 'abr', 'may', 'jun', 'jul', 'ago', 'sep', 'oct', 'nov', 'dic'];
    function sumarHabiles(dias) {
      var f = new Date();
      while (dias > 0) {
        f.setDate(f.getDate() + 1);
        if (f.getDay() !== 0 && f.getDay() !== 6) dias--;
      }
      return f;
    }
    function texto(f) { return f.getDate() + ' ' + meses[f.getMonth()]; }
    document.querySelectorAll('[data-nb-envio] [data-nb-fecha]').forEach(function (el) {
      var r = el.getAttribute('data-nb-fecha').split(',').map(Number);
      if (!r[1]) return;
      var desde = texto(sumarHabiles(r[0])), hasta = texto(sumarHabiles(r[1]));
      el.textContent = desde === hasta ? desde : desde + ' – ' + hasta;
    });
  }

  function iniciar() { initReveal(); initGaleria(); initVariantes(); initDisparadores(); initParallax(); initCarrusel(); initPacks(); initOnline(); initTabs(); initEnvio(); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', iniciar);
  else iniciar();
  document.addEventListener('shopify:section:load', function () { window.__nbIniciado = false; initReveal(); initGaleria(); });
})();
